import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LibraryItem } from '../../../core/pipes/filter-user-library.pipe';

import { Template } from 'fitforce-document-sync';

export interface AddFromTemplateDialogComponentData {
  title: String;
  items: Template[];
  label: String;
  buttons?: AddFromTemplateDialogComponentButton[];
}

export interface AddFromTemplateDialogComponentButton {
  label: String;
  callBack: Function;
}


@Component({
  selector: 'add-from-template-dialog',
  templateUrl: './add-from-template-dialog.component.html',
  styleUrls: ['./add-from-template-dialog.component.css']
})
export class AddFromTemplateDialogComponent implements OnInit {
  // searchText:string = '';
  libraryItems: LibraryItem[] = [];
  form: FormGroup;
  selected = false;
  selectedIndex = -1;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AddFromTemplateDialogComponentData,
    private dialog: MatDialogRef<AddFromTemplateDialogComponent>,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    if (this.data.items) {
      this.data.items.forEach(item => {
        this.libraryItems.push({type: this.data.label, item: item});
      });
    }


    this.form = this.formBuilder.group({
      searchText: this.formBuilder.control(''),
      boxes: new FormArray([]),
    });

    this.generateBoxes();

    this.onChanges();
  }

  get controls() {
    return {
      searchText: this.form.get('searchText'),
      boxes: this.form.get('boxes'),
    };
  }

  /**
   * Generates all boxes from libraryItems []
   */
  private generateBoxes() {
    this.libraryItems.forEach((o, i) => {
      const control = new FormControl(false); // if first item set to true, else false
      (this.form.controls.boxes as FormArray).push(control);
    });
  }

  onChanges(): void {
    this.controls.boxes.valueChanges.subscribe(val => {
      // get index of checked box
      const tempIndex = val.indexOf(true);

      // Note: disabling/enabling form items triggers 'onChanges'
      // Must keep track of what is selected to prevent loop

      // When selecting a box:
      // If one checkbox is checked and nothing is selected
      if (tempIndex >= 0 && !this.selected) {
        // set selected to true and disable all boxes except checked one
        this.selected = true;
        this.selectedIndex =  tempIndex;
        this.disableBoxes([this.selectedIndex]);
      }

      // When deselecting a box:
      // If no checkbox is checked and we had something selected
      if (tempIndex === -1 && this.selected) {
        // set selected to true, enable all boxes
        this.selected = false;
        this.selectedIndex =  tempIndex;
        this.enableBoxes();
      }
    });
  }

  /**
   * Disables all boxes except specifier array
   * @param indexes - indices that won't be disabled
   */
  private disableBoxes(indexes: number[]): void {
      (this.controls.boxes as FormArray).controls.forEach((box, i) => {
        if (!indexes.includes(i)) {
          box.disable();
        }
      });
  }

  /**
   * Enables all boxes
   */
  private enableBoxes(): void {
    (this.controls.boxes as FormArray).controls.forEach((box) => {
      box.enable();
    });
  }

  /**
   * Return selected item
   */
  addSelected() {
    this.dialog.close(this.libraryItems[this.selectedIndex].item);
  }

  /**
   * Closes dialog and returns call back of pressed
   * @param index index of button being pressed
   */
  buttonClick(index: number) {
    this.dialog.close(this.data.buttons[index].callBack());
  }
  cancel() {
    this.dialog.close();
  }
}
